import { CircularProgress } from '@mui/material'
import { Dimensioner } from '../../../../helpers/FreightSnap/types'
import { ScanIcon } from './DimensionerIcons'

interface Props {
    dimensioners: Dimensioner[]
    selectedId: string
    loading: boolean
    needsScan: boolean
    hasData?: boolean
    onSelect: (value: string) => void
    onScan: () => void
}

const DimensionerScanControls = ({dimensioners, selectedId, loading, needsScan, hasData, onSelect, onScan}: Props) => (
    <>
        <style>{`
            @keyframes fs-scan-beat { 0%,55%,100%{transform:scale(1);} 18%{transform:scale(1.06);} 36%{transform:scale(1.02);} }
            @keyframes fs-scan-ring { 0%{box-shadow:0 0 0 0 rgba(0,158,247,.40);} 70%{box-shadow:0 0 0 9px rgba(0,158,247,0);} 100%{box-shadow:0 0 0 0 rgba(0,158,247,0);} }
            .fs-scan-attention { animation: fs-scan-beat 1.6s ease-in-out infinite, fs-scan-ring 1.6s ease-out infinite; }
            @media (prefers-reduced-motion: reduce) { .fs-scan-attention { animation: none !important; } }
        `}</style>
        <div className="mb-4">
            <label className="text-uppercase d-block" style={{fontSize: 10, fontWeight: 600, letterSpacing: '.06em', color: '#A1A5B7', marginBottom: 6}}>Dimensioner</label>
            <div className="d-flex" style={{gap: 9}}>
                <select className="form-select form-select-sm" style={{flex: 1, height: 42}} value={selectedId} onChange={(e) => onSelect(e.target.value)}>
                    <option value="">Select a dimensioner</option>
                    {dimensioners.map((d) => (
                        <option key={String(d.dimensionerId)} value={String(d.dimensionerId)}>{d.name}</option>
                    ))}
                </select>
                <button type="button" className={`btn btn-primary d-flex align-items-center${needsScan ? ' fs-scan-attention' : ''}`} style={{height: 42, padding: '0 16px'}} disabled={!selectedId || loading} onClick={onScan}>
                    <ScanIcon size={15}/>
                    <span className="ms-2">Scan</span>
                    {loading && <CircularProgress style={{height: 14, width: 14, color: 'white'}} className="ms-2"/>}
                </button>
            </div>
            {needsScan && (
                <div className="d-flex align-items-center" style={{marginTop: 8, fontSize: 11.5, fontWeight: 500, color: '#009EF7'}}>
                    <ScanIcon size={13}/>
                    <span className="ms-2">Press <strong>Scan</strong> to measure this piece</span>
                </div>
            )}
            {hasData && !selectedId && !loading && (
                <div style={{marginTop: 8, fontSize: 11.5, fontWeight: 500, color: '#A1A5B7'}}>
                    Showing the saved scan. Pick a dimensioner to scan again.
                </div>
            )}
        </div>
    </>
)

export default DimensionerScanControls
